<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1000px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-row">
      <el-form class="input-w240" :inline="true" label-width="75px" label-position="right">
        <el-form-item :label="$t('RailwayExport.OrderNo2')+':'">
          <el-input
            v-model="order.orderNo"
            no="orderNo"
            :disabled="true"
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
        <el-form-item
          v-if="orderType===3"
          :label="$t('RailwayExport.BoxOwner3')+':'"
          style="margin-left: 40px;"
        >
          <cargo-advance-select
            no="sellerId"
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{active:true}"
            filterable
            :default-value="order.sellerId||''"
            style="width: 200px;margin-left: 40px;"
            @parentCallBack="p=>{order.sellerId=p.value}"
          />
        </el-form-item>
        <el-form-item
          v-if="orderType===2"
          :label="$t('RailwayExport.Buyer2')+':'"
          style="margin-left: 40px;"
        >
          <cargo-advance-select
            no="buyerId"
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{active:true}"
            filterable
            :default-value="order.buyerId||''"
            style="width: 200px;margin-left: 40px;"
            @parentCallBack="p=>{order.buyerId=p.value}"
          />
        </el-form-item>
        <el-form-item
          v-if="orderType!==3&&orderType!==2"
          :label="$t('RailwayExport.BoxOwner2')+':'"
          style="margin-left: 40px;"
        >
          <cargo-advance-select
            no="sellerId"
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{active:true}"
            filterable
            :default-value="order.sellerId||''"
            style="width: 200px;margin-left: 40px;"
            @parentCallBack="p=>{order.sellerId=p.value}"
          />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="orderType===3" class="app-main-row">
      <el-form class="input-w240" :inline="true" label-width="75px" label-position="right">
        <el-form-item :label="$t('RailwayExport.RentDate')+':'">
          <el-date-picker
            v-model="order.rentDate"
            no="rentDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.ReturnDate')+':'" style="margin-left: 40px;">
          <el-date-picker
            v-model="order.returnDate"
            no="returnDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row">
      <el-form class="input-w240" :inline="true" label-width="75px" label-position="right">
        <el-form-item
          v-show="orderType!==3&&orderType!==2"
          :label="$t('RailwayExport.BuyTime')+':'"
        >
          <el-date-picker
            v-model="order.buyerDate"
            no="buyerDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
        <el-form-item v-show="orderType===2" :label="$t('RailwayExport.SellerDate')+':'">
          <el-date-picker
            v-model="order.sellerDate"
            no="sellerDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
        <el-form-item
          :label="$t('RailwayExport.SettlingTime')+':'"
          :style="{marginLeft:orderType!==3?'40px':''}"
        >
          <el-date-picker
            v-model="order.settlementDate"
            no="settlementDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row">
      <div style="width: 680px;display: flex;">
        <div style="width: 386px;padding-left: 11px;margin-right: 70px;">
          {{ $t('RailwayExport.QuantitySum') }}：{{ containerLabel }}&nbsp;&nbsp;
          {{ $t('RailwayExport.AmountSum') }}：{{ amountLabel }} {{ amountLabel ? container.currencyCode : '' }}
        </div>
        <div>
          {{ $t('RailwayExport.WhetherSettlement') }}：
          <el-select v-model="order.ifSettlement" no="ifSettlement" style="width: 160px;">
            <el-option
              v-for="(item,index) in JUDGE_STATUS"
              :key="index"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div class="app-main-row" style="margin: 5px 0;border-bottom: 1px solid #adaeb1;" />
    <div class="app-main-row">
      <el-form class="input-w160" :inline="true" label-width="60px" label-position="left">
        <el-form-item :label="$t('RailwayExport.EQSize')">
          <cargo-advance-select
            no="eqsize"
            :select-type="TYPE_NAMES.local_cache_EQSize3"
            :fields="['code']"
            filterable
            :default-value="container.eqsize"
            tag-name="code"
            @parentCallBack="p=>{container.eqsize=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.EQType')">
          <cargo-advance-select
            no="eqtype"
            :select-type="TYPE_NAMES.basic_data_EQType"
            :fields="['code']"
            filterable
            :default-value="container.eqtype"
            tag-name="code"
            @parentCallBack="p=>{container.eqtype=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.Quantity2')">
          <el-input-number v-model="cQ" no="cQ" :precision="0" :controls="false" :min="0" :max="999" />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row" style="margin-bottom: 6px;">
      <el-form class="input-w160" :inline="true" label-width="60px" label-position="left">
        <el-form-item :label="$t('RailwayExport.UnitRate')">
          <el-input-number v-model="container.unitPrice" no="unitPrice" :precision="2" :controls="false" :min="0" />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.CurrencyCode')">
          <cargo-advance-select
            :disabled="rowData.length>0||Boolean(railway&&railway.currencyCode)"
            no="currencyCode"
            :select-type="TYPE_NAMES.basic_data_Currency"
            :fields="['code']"
            filterable
            :default-value="container.currencyCode"
            tag-name="code"
            @parentCallBack="p=>{container.currencyCode=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
          <el-input v-model="container.remarks" no="remarks" maxlength="50" />
        </el-form-item>
      </el-form>
      <el-button no="Add" type="primary" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
    </div>
    <div class="app-main-row">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;height: 300px"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer">
      <el-button no="Confirm" type="primary" @click="successHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
    <!-- 组件样式模板（用于嵌入ag-grid）-->
    <div v-show="false">
      <el-button
        ref="deleteBtnTemplate"
        type="primary"
        no="1"
        onclick="void(0)"
      >{{ $t('RailwayExport.Delete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import * as BoxTubeConstants from '@/class/cargo/model/parameters/BoxTubeConstants'
import { RailwayContainer } from '@/class/model/booking/RailwayContainer'
import { RailwayContainerOrder } from '@/class/model/booking/RailwayContainerOrder'
import { queryContainerDetail, createOrder, updateOrder } from '@/api/railwayExport/railwayContainerOrder'

export default {
  name: 'BoxOperationDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, default: null },
    title: { type: String, required: true },
    orderType: { type: Number, required: true },
    isEdit: { type: Boolean, required: false },
    railway: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      order: new RailwayContainerOrder().fillDefaultValue().getData(),
      containerLabel: '',
      amountLabel: '',
      container: new RailwayContainer().fillDefaultValue().getData(),
      cQ: 1,
      rowData: [],
      deleteContainerKeys: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('RailwayExport.ContainerNo'),
          field: 'containerno',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-cell-input'
          }
        },
        {
          headerName: this.orderType === 3 ? this.$t('RailwayExport.Amount') : this.$t('RailwayExport.UnitRate'),
          field: 'unitPrice',
          width: 150
        },
        {
          headerName: this.$t('RailwayExport.CurrencyCode'),
          field: 'currencyCode',
          width: 100
        },
        {
          headerName: this.$t('RailwayExport.EQSize'),
          field: 'eqsize',
          width: 150
        },
        {
          headerName: this.$t('RailwayExport.EQType'),
          field: 'eqtype',
          width: 150
        },
        {
          headerName: this.$t('RailwayExport.JobNo2'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('RailwayExport.ContainerStatus'),
          field: 'containerStatus',
          width: 150,
          cellRenderer: params => {
            const container = BoxTubeConstants.getContainerByCode(params.value)
            return container ? container.chineseName : ''
          }
        },
        {
          headerName: this.$t('RailwayExport.Operation'),
          width: 150,
          cellRenderer: params => {
            if (params.data.containerStatus !== 3 && !this.look) {
              const html = this.$refs.deleteBtnTemplate.$el.outerHTML
              const methodPath = this.documentManage.getPath('deleteHandler')
              return html.replace('void(0)', `${methodPath}(${params.data.seq})`)
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          width: 150,
          hide: true
        }
      ]
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal && this.railway) {
          queryContainerDetail({ key: this.railway.uuid }).then(res => {
            Object.assign(this.order, this.railway)
            if (this.railway.currencyCode) {
              this.container.currencyCode = this.railway.currencyCode
            }
            for (const item of res.data) {
              item.seq = this.autoIncrementNum.getNextNum()
            }
            this.rowData = res.data
            this.calculationBox()
            this.calculationAmountSum()
          })
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      if (!newVal) {
        new RailwayContainerOrder(this.order).reset()
        new RailwayContainer(this.container).reset()
        this.containerLabel = ''
        this.amountLabel = ''
        this.cQ = 1
        this.rowData = []
        this.deleteContainerKeys = []
        this.$emit('resultFunction')
      }
      this.$emit('update:visible', newVal)
    },
    orderType: {
      handler(newVal) {
        if (newVal === 2) {
          this.container.containerStatus = 3
        } else {
          this.container.containerStatus = 1
        }
      },
      immediate: true
    }
  },
  created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.JUDGE_STATUS = BoxTubeConstants.JUDGE_STATUS
    this.gridOptions = {
      rowSelection: 'single',
      suppressCellSelection: true,
      rowHeight: 32,
      onRowDataChanged: event => {
        // 清除单选行
        event.api.clearFocusedCell()
      },
      context: {
        componentParent: this
      }
    }
    this.gridApi = null
    this.autoIncrementNum = new AutoIncrementNum()
    this.documentManage = new DocumentManage()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('deleteHandler', function(seq) {
      self.deleteHandler(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    addHandler() {
      const container = this.container
      if (!container.eqsize || !container.eqtype) {
        this.$message.info(this.$t('Message.PleaseSelectBoxType'))
        return
      }
      if (!(container.unitPrice > 0)) {
        this.$message.info(this.$t('Message.PleaseEnterUnitPrice'))
        return
      }
      if (!container.currencyCode) {
        this.$message.info(this.$t('Message.PleaseSelectCurrency'))
        return
      }
      if (this.orderType === 3) {
        if (!this.order.rentDate) {
          this.$message.info(this.$t('Message.PleaseEnterTheStartDate'))
          return
        }
        if (!this.order.returnDate) {
          this.$message.info(this.$t('Message.PleaseEnterEndDate'))
          return
        }
      }
      for (let i = 0; i < this.cQ; ++i) {
        const data = { seq: this.autoIncrementNum.getNextNum(), ...this.container }
        data.containerStatus = 1
        this.rowData.push(data)
      }
      this.calculationBox()
      this.calculationAmountSum()
    },
    // 计算列表箱量
    calculationBox() {
      const m = new Map()
      for (const item of this.rowData) {
        const val = m.get(item.eqsize + item.eqtype)
        if (val) {
          m.set(item.eqsize + item.eqtype, val + 1)
        } else {
          m.set(item.eqsize + item.eqtype, 1)
        }
      }
      let text = ''
      for (const key of m.keys()) {
        if (text) {
          text += ','
        }
        text += key + '*' + m.get(key)
      }
      this.containerLabel = text
    },
    calculationAmountSum() {
      let amount = 0
      for (const item of this.rowData) {
        amount += item.unitPrice
      }
      this.amountLabel = amount.toFixed(2)
    },
    deleteHandler(seq) {
      const index = this.rowData.findIndex(p => p.seq === seq)
      const row = this.rowData[index]
      if (row && row.containerStatus === 2) {
        this.$message.warning(this.$t('Message.NowContainerCanNotDelete'))
        return
      }
      if (row.uuid) {
        this.deleteContainerKeys.push(row.uuid)
      }
      this.rowData.splice(index, 1)
      this.calculationBox()
      this.calculationAmountSum()
    },
    async successHandler() {
      if (this.rowData.length === 0) {
        this.$message.info(this.$t('Message.PleaseContainerData'))
        return
      }
      await cache.load(cacheName.OFFICE)
      const params = {}
      params.officeNo = cache.office.code
      params.orderType = this.orderType
      params.buyerId = this.order.buyerId
      if (params.buyerId) {
        params.buyerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.buyerId, 'chineseName')
      }
      params.sellerId = this.order.sellerId
      if (params.sellerId) {
        params.sellerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.sellerId, 'chineseName')
      }
      params.ifSettlement = this.order.ifSettlement
      params.settlementDate = this.order.settlementDate
      params.buyerDate = this.order.buyerDate
      params.sellerDate = this.order.sellerDate
      params.rentDate = this.order.rentDate
      params.returnDate = this.order.returnDate
      params.currencyCode = this.container.currencyCode
      if (this.isEdit) {
        params.orderKey = this.railway.uuid
        params.deleteContainerKeys = this.deleteContainerKeys.join(',')
        await updateOrder(this.rowData, params)
      } else {
        await createOrder(this.rowData, params)
      }
      this.innerVisible = false
      this.$message.success(this.$t('Message.SaveSucceed'))
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-inner .app-main-row {
  .input-w240 ::v-deep {
    .el-form-item__content {
      width: 240px;
      .el-input-number--mini {
        width: 100%;
      }
    }
  }
  .input-w160 ::v-deep {
    .el-form-item__content {
      width: 160px;
      .el-input-number--mini {
        width: 100%;
      }
    }
  }
}
</style>
